<template>
    <thead class="ut-text-neutral-400">
        <tr class="ut-font-semibold ut-text-neutral-400">
            <th class="ut-py-6">Address</th>
            <th class="ut-pl-3">Vendor</th>
            <th class="ut-pl-3">Referred</th>
            <th class="ut-pl-3 listed-header">
                <span>Listed</span>
                <svg-icon v-tooltip="{ content: listedInfo, trigger: 'hover click' }" 
                    :icon="'icon-info'"
                    :size="14"
                    :addClass="'ut-text-neutral-400'"></svg-icon>
            </th>
            <th class="ut-pl-3">Agent</th>
            <th class="ut-pl-3">Payment Status</th>
        </tr>
    </thead>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';

export default {
  name: 'ListingReferralTableHead',
  components: {
    SvgIcon,
  },
  data() {
      return {
          listedInfo: 'Date listed is based on the point in time when OpenAgent were notified the referral was going to market. This information comes from multiple sources and could be slightly different to the actual day the property appeared in listing portals.',
      }
  }
};
</script>

<style lang="scss" scoped>
.listed-header span {
    @apply ut-float-left;
}
.listed-header div {
    @apply ut-ml-1 ut-float-left;
}
</style>
